import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function startCheckout(productId) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: productId,
    origin_url: window.location.origin,
  });
  if (!data?.checkout_url) throw new Error("No checkout url");
  window.location.href = data.checkout_url;
}
